export interface LetPassAccountEntity {

    id: number,
    receiptNo?: string | null,
    companyCode?: string | null,
    transactionDate?: Date | null,
    transactionType?: string | null,
    paymentMode?: string | null,
    bankCode?: string | null,
    payOrderNo?: string | null,
    transactionAmount?: number | null,
    transactionDesc?: string | null,
    createdBy?: string | null,
    activeInd?: string | null,
    lpaBalance: number,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_LET_PASS_ACCOUNT_ENTITY: LetPassAccountEntity = {
    id: 0,
    receiptNo: null,
    companyCode: null,
    transactionDate: null,
    transactionType: null,
    paymentMode: null,
    bankCode: null,
    payOrderNo: null,
    transactionAmount: null,
    transactionDesc: null,
    createdBy: null,
    activeInd: 'Y',
    lpaBalance: 0
}
